// TAAS Data Layer events: donate_step_1, donate_step_2, purchase

const safeGet = (obj, path, fallback = undefined) => {
	try {
		return (
			path
				.split(".")
				.reduce((acc, key) => (acc == null ? acc : acc[key]), obj) ?? fallback
		);
	} catch (e) {
		return fallback;
	}
};

const getFrequencyCategory = (frequency) => {
	const f = String(frequency || "").toLowerCase();
	if (f.includes("month")) return "Monthly Donation";
	if (f.includes("single")) return "One-Off Donation";
	return "One-Off Donation";
};

const buildItemName = (serviceCode, frequency, donationReason) => {
	const brand = serviceCode || "";
	const base = `${brand} ${getFrequencyCategory(frequency).replace(
		" Donation",
		""
	)}`;
	const isInMemory = String(donationReason || "")
		.toLowerCase()
		.includes("memory");
	return isInMemory ? `${base} Donation - In Memory` : `${base} Donation`;
};

const resolvePaymentType = (formValues) => {
	const fromResponse = safeGet(formValues, "responses.payment_method");
	if (fromResponse) return fromResponse;
	const method = safeGet(formValues, "paymentmethod");
	switch (method) {
		case "direct_debit":
			return "Direct Debit";
		case "credit_debit":
			return "Credit/Debit";
		case "paypal":
			return "PayPal";
		case "digital_wallet":
			return "Digital Wallet";
		default:
			return undefined;
	}
};

const buildEcommercePayload = (formValues) => {
	const amountRaw = safeGet(
		formValues,
		"donation_frequency_and_amount.amount",
		0
	);
	const amount = Number(amountRaw) || 0;
	const currency =
		safeGet(formValues, "donation_frequency_and_amount.currency", "GBP") ||
		"GBP";
	const service = safeGet(formValues, "service", "");
	const donationReason = safeGet(formValues, "donation_reason");
	const frequency = safeGet(
		formValues,
		"donation_frequency_and_amount.frequency",
		"Single"
	);
	const transactionId = safeGet(formValues, "responses.donation_id");
	const paymentType = resolvePaymentType(formValues);

	const item = {
		item_name: buildItemName(service, frequency, donationReason),
		item_brand: service || undefined,
		item_category: getFrequencyCategory(frequency),
		price: amount,
		quantity: 1,
	};

	return {
		transaction_id: transactionId,
		value: amount,
		reason: donationReason,
		currency,
		payment_type: paymentType,
		items: [item],
	};
};

export const trackDonateStep = (stepNumber, formValues) => {
	if (typeof window === "undefined") return;
	window.dataLayer = window.dataLayer || [];
	const ecommerce = buildEcommercePayload(formValues);
	window.dataLayer.push({ event: `donate_step_${stepNumber}`, ecommerce });
};

export const trackPurchase = (formValues) => {
	if (typeof window === "undefined") return;
	window.dataLayer = window.dataLayer || [];
	const ecommerce = buildEcommercePayload(formValues);
	window.dataLayer.push({ event: "purchase", ecommerce });
};

export const trackMonthlyUpsellView = (formValues, suggestedMonthlyAmount) => {
	if (typeof window === "undefined") return;
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: "donation_monthly_upsell_view",
		ecommerce: buildEcommercePayload(formValues),
		suggested_monthly_amount: suggestedMonthlyAmount,
	});
};

export const trackMonthlyUpsellAccept = (
	formValues,
	suggestedMonthlyAmount,
) => {
	if (typeof window === "undefined") return;
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: "donation_monthly_upsell_accept",
		ecommerce: buildEcommercePayload(formValues),
		suggested_monthly_amount: suggestedMonthlyAmount,
	});
};

export const trackMonthlyUpsellDecline = (formValues, suggestedMonthlyAmount) => {
	if (typeof window === "undefined") return;
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: "donation_monthly_upsell_decline",
		ecommerce: buildEcommercePayload(formValues),
		suggested_monthly_amount: suggestedMonthlyAmount,
	});
};

export const trackMonthlyUpsellChoice = (
	choice,
	formValues,
	suggestedMonthlyAmount,
) => {
	if (typeof window === "undefined") return;
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: "monthly_upsell_choice",
		monthly_upsell_choice: choice,
		ecommerce: buildEcommercePayload(formValues),
		suggested_monthly_amount: suggestedMonthlyAmount,
	});
};

export default {
	trackDonateStep,
	trackPurchase,
	trackMonthlyUpsellView,
	trackMonthlyUpsellAccept,
	trackMonthlyUpsellDecline,
	trackMonthlyUpsellChoice,
};
